import type { Article } from "../../../types/blog";

const article: Article = {
  slug: "publicites-popups-intempestifs",
  silo: "securite",
  h1: "Publicités et pop-ups intempestifs sur mon PC : comment s'en débarrasser ?",
  metaTitle: "Pop-ups et pubs sur PC : supprimer les adwares",
  metaDescription: "Des publicités envahissent votre écran ? C'est souvent un adware. Découvrez comment nettoyer votre PC proprement et rapidement.",
  excerpt: "Des fenêtres publicitaires s'ouvrent sans arrêt, même quand vous n'utilisez pas votre navigateur ? C'est le signe d'un adware installé sur votre PC. Voici comment l'identifier et le supprimer définitivement.",
  publishedAt: "2024-02-25",
  readingMinutes: 5,
  relatedSlugs: ["virus-malware-ordinateur", "erreurs-windows-frequentes", "logiciel-plante-ne-souvre-pas"],
  faq: [
    {
      question: "Les pop-ups sont-ils dangereux ?",
      answer: "Les pop-ups publicitaires sont souvent gênants mais pas forcément dangereux en eux-mêmes. En revanche, cliquer dessus peut mener à des sites malveillants ou installer d'autres logiciels indésirables. Ne cliquez jamais sur ces fenêtres.",
    },
    {
      question: "Comment des pubs apparaissent-elles même quand mon navigateur est fermé ?",
      answer: "C'est la signature d'un adware installé sur Windows lui-même, pas dans le navigateur. Il s'exécute en arrière-plan et affiche des notifications Windows déguisées en publicités.",
    },
    {
      question: "Est-ce que supprimer l'historique du navigateur résout le problème ?",
      answer: "Non. Vider l'historique ne supprime pas un adware installé sur le système. Il faut utiliser des outils spécialisés pour le détecter et l'éliminer complètement.",
    },
  ],
  content: [
    {
      type: "p",
      text: "Si des publicités apparaissent sur votre bureau, dans votre navigateur ou sous forme de notifications Windows que vous n'avez pas demandées, votre PC héberge très probablement un adware -- un logiciel publicitaire indésirable.",
    },
    {
      type: "h2",
      text: "Pourquoi ces publicités apparaissent-elles ?",
    },
    {
      type: "p",
      text: "Les adwares s'installent généralement à votre insu, le plus souvent en accompagnant un logiciel gratuit téléchargé depuis un site non officiel. Lors de l'installation, une case pré-cochée vous fait accepter l'installation d'un 'bonus' non désiré. Les logiciels de téléchargement de fichiers, les faux 'nettoyeurs PC' et les extensions de navigateur douteuses sont les principaux vecteurs.",
    },
    {
      type: "h2",
      text: "Types de publicités intempestives les plus courants",
    },
    {
      type: "ul",
      items: [
        "Pop-ups dans le navigateur sur des sites qui n'en ont pas d'habitude",
        "Redirections vers des sites inconnus quand vous cliquez sur un lien",
        "Notifications Windows avec des offres promotionnelles ou des alertes de sécurité fausses",
        "Bandeau publicitaire ajouté en haut ou en bas de toutes les pages web",
        "Moteur de recherche changé dans votre navigateur (Bing, Yahoo, ou un moteur inconnu)",
      ],
    },
    {
      type: "callout",
      variant: "warning",
      title: "Ne cliquez jamais sur ces messages",
      text: "Les pop-ups qui vous disent 'Votre PC est infecté, cliquez ici pour nettoyer' ou 'Vous avez gagné un prix' sont eux-mêmes des pièges. Cliquer dessus installe souvent d'autres malwares.",
    },
    {
      type: "h2",
      text: "Comment supprimer les publicités et adwares",
    },
    {
      type: "ol",
      items: [
        "Vérifiez les programmes installés récemment : Paramètres > Applications, triez par date d'installation et désinstallez ce que vous ne reconnaissez pas",
        "Ouvrez votre navigateur et vérifiez les extensions : supprimez tout ce que vous n'avez pas installé vous-même",
        "Remettez la page d'accueil et le moteur de recherche à leurs valeurs d'origine dans les paramètres du navigateur",
        "Lancez une analyse avec Malwarebytes (version gratuite) pour détecter les adwares",
        "Lancez AdwCleaner (logiciel gratuit de Malwarebytes) spécialement conçu pour les adwares",
        "Redémarrez le PC et vérifiez que les publicités ont disparu",
      ],
    },
    {
      type: "h2",
      text: "Et si les publicités reviennent après nettoyage ?",
    },
    {
      type: "p",
      text: "Certains adwares sont persistants et se réinstallent automatiquement. Cela peut signifier qu'un [virus plus profond](slug:virus-malware-ordinateur) est présent sur votre système. Nos techniciens peuvent identifier et supprimer les menaces tenaces lors d'une intervention à domicile ou sur site, en utilisant des outils professionnels que les antivirus grand public ne peuvent pas déployer seuls.",
    },
    {
      type: "h2",
      text: "Comment éviter les adwares à l'avenir",
    },
    {
      type: "ul",
      items: [
        "Téléchargez les logiciels uniquement depuis les sites officiels des éditeurs",
        "Lors d'une installation, choisissez toujours 'Installation personnalisée' pour décocher les logiciels bonus",
        "Installez un bloqueur de publicités dans votre navigateur (uBlock Origin est gratuit et efficace)",
        "Méfiez-vous des sites qui vous proposent de télécharger Flash Player ou Java -- ces messages sont presque toujours des pièges",
      ],
    },
  ],
};

export default article;
